import { Button, Card, CardContent, CardMedia, Typography } from '@mui/material';
import KeyboardArrowLeftIcon from '@mui/icons-material/KeyboardArrowLeft';
import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';

interface IProps {
	title: string;
	price: number;
	image?: string;
	link: string;
}

export default function PackageItem({ title, price, image, link }: IProps) {
	const { t } = useTranslation();

	return (
		<Card className={'rounded-lg border border-primary-main/50 p-4 shadow-none'}>
			<CardMedia className={'rounded'} component="img" height="140" image={image} />
			<CardContent className={'flex flex-col items-center p-0 py-6 sm:flex sm:flex-row sm:justify-between'}>
				<Typography className={'text-base font-medium text-text-primary'}>{title}</Typography>
				<Typography className={'text-base font-medium text-text-secondary'}>{price}</Typography>
			</CardContent>
			<Button component={Link} to={link} endIcon={<KeyboardArrowLeftIcon />} fullWidth variant={'contained'}>
				{t('see-more')}
			</Button>
		</Card>
	);
}
